import { Assembly } from '@/__generated__/graphql';
import { NOT_APPLICABLE_LABEL } from '@/constants';
import { FormControlLabel, Tooltip, Typography } from '@mui/material';
import { StyledCheckbox } from '../styles';
import { Card, DetailRow } from './styles';
import { useComponentCardData } from '../hooks/useComponentCardData';

export const ComponentCard = ({ component }: { component: Partial<Assembly> }) => {
  const {
    isSelectedComponent,
    handleCardEnter,
    handleCardLeave,
    handleChecked,
    handleComponentCardClick,
    isChecked,
    subtitle,
    topRight,
    bottomRight,
  } = useComponentCardData(component);

  return (
    <Card
      highlighted={isSelectedComponent}
      onClick={() => handleComponentCardClick(component?.id ?? '', component?.tagName ?? '')}
      onMouseEnter={handleCardEnter}
      onMouseLeave={handleCardLeave}
    >
      <DetailRow>
        <FormControlLabel
          sx={{ margin: 0 }}
          control={
            <StyledCheckbox
              highlighted={isSelectedComponent}
              disableRipple
              checked={isChecked}
              onChange={handleChecked}
              onClick={(event) => event.stopPropagation()}
            />
          }
          label={
            <Tooltip title={component?.tagName ?? ''} placement="top" arrow>
              <Typography
                variant="h6"
                lineHeight="normal"
                color={isSelectedComponent ? 'primary.50' : 'primary.500'}
                sx={{
                  maxWidth: '20rem',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {component?.tagName ?? NOT_APPLICABLE_LABEL}
              </Typography>
            </Tooltip>
          }
        />
        {topRight}
      </DetailRow>
      <DetailRow>
        {subtitle}
        {bottomRight}
      </DetailRow>
    </Card>
  );
};
